"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolEchainCalculationFormulas = exports.RolEchainPartNames = void 0;
var RolEchainPartNames;
(function (RolEchainPartNames) {
    RolEchainPartNames["Part1a"] = "Part1a";
    RolEchainPartNames["Part1b"] = "Part1b";
    RolEchainPartNames["Part1c"] = "Part1c";
    RolEchainPartNames["Part1d"] = "Part1d";
    RolEchainPartNames["Part1e"] = "Part1e";
    RolEchainPartNames["Part2"] = "Part2";
    RolEchainPartNames["Part3"] = "Part3";
    RolEchainPartNames["Part4"] = "Part4";
})(RolEchainPartNames = exports.RolEchainPartNames || (exports.RolEchainPartNames = {}));
var RolEchainCalculationFormulas;
(function (RolEchainCalculationFormulas) {
    RolEchainCalculationFormulas[RolEchainCalculationFormulas["Default"] = 1] = "Default";
    RolEchainCalculationFormulas[RolEchainCalculationFormulas["Two"] = 2] = "Two";
})(RolEchainCalculationFormulas = exports.RolEchainCalculationFormulas || (exports.RolEchainCalculationFormulas = {}));
//# sourceMappingURL=KettenSerieModel.js.map